export default {
    TITLE: "Добавление пользователя"
};
